/**
 * Ably channel names for the assistant.
 *
 * Tokens are scoped to `lou:v2:{user_id}:*`, so a user can only ever attach
 * to their own channels, and one token covers conversations that do not exist
 * yet.
 */

export const LOU_CHANNEL_PREFIX = "lou:v2";

/** The Ably event name every command arrives under. */
export const LOU_EVENT_NAME = "lou";

/** The conversation list. Attached for as long as the user is signed in. */
export function controlChannel(userId: string | number): string {
  return `${LOU_CHANNEL_PREFIX}:${userId}:control`;
}

/** One conversation's turns. Attached only while that conversation is open. */
export function conversationChannel(
  userId: string | number,
  conversationId: string,
): string {
  return `${LOU_CHANNEL_PREFIX}:${userId}:conv:${conversationId}`;
}
